import { CalendarRange } from "lucide-react";
import type { ShiftFormManagerDashboardFilters } from "../../../shared/shift-production-form/contracts";
import { analysisDateRangeLabel } from "./analysis-date-range";

export function ProductionAnalysisEmpty({ filters, selectedReason }: { filters: ShiftFormManagerDashboardFilters; selectedReason?: string }) {
  const scope = filters.lineName ?? filters.departmentName ?? "Tüm bölümler";
  const date = filters.dateFrom && filters.dateTo ? analysisDateRangeLabel({ dateFrom: filters.dateFrom, dateTo: filters.dateTo }) : null;
  return <section className="pa-analysis-empty" role="status" aria-label="Duruş kaydı bulunamadı">
    <CalendarRange size={28} strokeWidth={1.4} aria-hidden="true" />
    <p className="pa-empty-context">{scope}{date ? <> · {date}</> : null}</p>
    <h2>Bu dönemde duruş kaydı yok</h2>
    <p>{selectedReason ? `“${selectedReason}” nedeni için bu seçimde kayıt bulunamadı.` : "Seçili kapsamda kayıtlı bir duruş bulunamadı."}</p>
    <p className="pa-empty-guidance">Diğer dönemleri incelemek için üstteki tarih oklarını veya tarih aralığını kullanın.</p>
  </section>;
}
